import React from 'react'
import { cn } from '@/utilities/cn'

interface BackgroundTextGlassProps {
    children: React.ReactNode
    className?: string
}

export const BackgroundTextGlass: React.FC<BackgroundTextGlassProps> = ({ children, className }) => {
    return (
        <div
            className={cn(
                // Exact match from CheckoutPage.tsx outer container
                'bg-neutral-900/60 dark:bg-black/40', // Darkened light mode bg for white text contrast
                'backdrop-blur-3xl',
                'rounded-3xl',
                'p-6 md:p-8',
                'border border-neutral-200/20 dark:border-white/10',
                // Colors
                'text-white', // Light mode text is white
                'dark:text-neutral-200', // Dark mode text default

                // Header Colors (Cascading)
                '[&_h1]:text-emerald-500 [&_h2]:text-emerald-500 [&_h3]:text-emerald-500 [&_h4]:text-emerald-500', // Light mode headers
                'dark:[&_h1]:text-[var(--neon-orange)] dark:[&_h2]:text-[var(--neon-orange)] dark:[&_h3]:text-[var(--neon-orange)] dark:[&_h4]:text-[var(--neon-orange)]', // Dark mode headers

                // Text Colors (Cascading - override text-muted-foreground)
                '[&_p]:text-white [&_li]:text-white [&_strong]:text-white', // Force light mode text white
                'dark:[&_p]:text-neutral-200 dark:[&_li]:text-neutral-200 dark:[&_strong]:text-white', // Dark mode text

                className
            )}
        >
            {children}
        </div>
    )
}
